import { PlaybookType } from './playbook'

export enum QuickActionOption {
    CAPTURE = 'capture',
    INSERT_LAST = 'insertLast',
    SEARCH = 'search',
}

export type QuickActionConfig = {
    url: string
    anchorQS: string
    injectionQS?: string
    value?: string
    anchorPlacement?: 'append' | 'prepend' | 'after' | 'before'
    anchorQSGoUp?: number // Gets n-th parent of the anchor query selector
    injectionPlacement?: 'before' | 'after' | 'none'
    actionType?: 'gif' | 'link' | 'copyGif' | 'customTemplate'
    actionIconSrc?: ''
    styles?: CSSStyleDeclaration
    popupStyles?: CSSStyleDeclaration
    isFrame?: boolean // If the anchor node is inside the iframe
    template?: string // Works only with actionType === 'customTemplate'
    options?: `${QuickActionOption}`[]
}

export type QuickActionResult = {
    playbook: PlaybookType
    frameId?: number | 'self'
    trackLinkId: string
    trackLinkName?: string
    uid?: string
}
